<template>
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 13C1.5 6.37258 6.87258 1 13.5 1C20.1274 1 25.5 6.37258 25.5 13C25.5 19.6274 20.1274 25 13.5 25C6.87258 25 1.5 19.6274 1.5 13Z"
      fill="#AABED4"
    />
    <path
      d="M1.5 13C1.5 6.37258 6.87258 1 13.5 1C20.1274 1 25.5 6.37258 25.5 13C25.5 19.6274 20.1274 25 13.5 25C6.87258 25 1.5 19.6274 1.5 13Z"
      stroke="white"
      stroke-width="2"
    />
    <g clip-path="url(#clip0_3168_35846)">
      <path
        d="M9 10C9 8.3455 10.346 7 12 7C13.654 7 15 8.3455 15 10C15 11.6545 13.6545 13 12 13C10.3455 13 9 11.6545 9 10ZM19.5 16C19.5 17.657 18.157 19 16.5 19C14.843 19 13.5 17.657 13.5 16C13.5 14.343 14.843 13 16.5 13C18.157 13 19.5 14.343 19.5 16ZM18.356 15.149C18.1645 14.9495 17.8475 14.944 17.649 15.1345L16.2925 16.4465C16.221 16.517 16.103 16.5185 16.0315 16.4475L15.3545 15.782C15.1565 15.588 14.8405 15.5915 14.6475 15.789C14.454 15.9865 14.457 16.3025 14.6545 16.496L15.3315 17.162C15.5615 17.3865 15.8625 17.499 16.163 17.499C16.4635 17.499 16.7635 17.3865 16.9895 17.1635L18.341 15.8565C18.54 15.665 18.5465 15.3485 18.3555 15.1495L18.356 15.149ZM12.5 16C12.5 15.316 12.6725 14.6725 12.975 14.1095C12.6605 14.0395 12.335 14 12 14C9.522 14 7.505 16.014 7.5 18.4915C7.4995 18.77 7.7215 19 8 19H13.8605C13.028 18.267 12.5 17.1965 12.5 16Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3168_35846">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(7.5 7)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
